import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../../layouts/sidebarProposal/SidebarProposal'
import { startLoading, doneLoading } from '../../../../utils/loading'
import PanalLoadingTemplate from '../../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ErrorWidget from '../../../../widgets/errorWidget/ErrorWidget'
import '../../styles.less'
import { getManageBankAccount } from '../../../../redux/actions/manageBankAccount'
import TaxSumReportWidget from '../../../../widgets/taxSumReportWidgets/TaxSumReportWidget'

export default function TaxSumReport() {
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()
  const projectCode = sessionStorage.getItem('projectCode')

  useEffect(() => {
    handleGetSchema(projectCode)
  }, [])

  const handleGetSchema = async (projectCode) => {
    setIsLoading(true)
    startLoading()
    try {
      // const response = await getManageBankAccount(projectCode)
      // setSchema(response.model)
      setSchema(mockSchema.model)
      console.log('mockSchema==>', schema)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal isIncomeAndExpense>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isIncomeAndExpense>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <div>
      {/* <SidebarProposal isIncomeAndExpense>
        <ContentHeader header={schema.header} subHeader={''} isNotCallApi /> */}
      {/* isShowGoButton //ย้อนหลัง */}

      <TaxSumReportWidget schema={schema} />

      <br />
      {/* </SidebarProposal> */}
    </div>
  )
}

const mockSchema = {
  affectedRows: 0,
  message: null,
  didError: false,
  errorMessage: null,
  model: {
    header: 'รายงานสรุปภาษีรายปี',
    subHeader: ' ',
    disabled: false,
    projectCode: {
      name: 'projectCode',
      label: 'รหัสโครงการ',
      value: '66-00019',
    },
    projectName: {
      name: 'projectName',
      label: 'ชื่อโครงการ',
      value: 'โครงการ1',
    },
    modelType: {
      name: 'modelType',
      label: 'ประเภทแบบ',
      value: '',
      options: [
        {
          disabled: false,
          label: 'ภ.ง.ด.1',
          value: '1',
        },
        {
          disabled: false,
          label: 'ภ.ง.ด.3',
          value: '2',
        },
        {
          disabled: false,
          label: 'ภ.ง.ด.53',
          value: '3',
        },
      ],
      validators: [
        {
          type: 'REQUIRED',
          value: null,
          errorMessage: 'กรุณาเลือกรายการ',
        },
      ],
    },
    fileseFillingValues: [
      {
        taxid: '1234567891023',
        nameEarner: 'นายโบวา เยล',
        addressEarner: '',
        amountIncomeYear: '100000',
        amountTaxYear: '1000',
        condition: '',
        isRowTotal: false,
      },
      {
        taxid: '1234567891023',
        nameEarner: 'นางสาวสุภัทรา เรืองวานิช',
        addressEarner: '',
        amountIncomeYear: '200000',
        amountTaxYear: '2000',
        condition: '',
        isRowTotal: false,
      },
      {
        taxid: '',
        nameEarner: '',
        addressEarner: 'รวมยอดเงินได้และภาษีที่นำส่ง',
        amountIncomeYear: 300000,
        amountTaxYear: 0,
        condition: '',
        isRowTotal: true,
      },
    ],
  },
}
